export default __webpack_public_path__ + "static/media/property_889.09f5ef17.png";